export default __webpack_public_path__ + "static/media/weights-exercise-weightlifter-strong-athletic_1139-709.ac52b18e.jpg";